<template>
    <div class="letter">
        <div v-for="(item, index) in editData.question" :key="index" class="remarks">
            <div style="margin-top: 20px;">
                <div class="delete">
                    <div>问题{{ index+1 }}：</div>
                    <!-- <div><el-button type="text" @click="deleteFn(index)"> 删除</el-button></div> -->
                </div>
                <div style="margin-top: 10px;">
                    <el-input
                        type="textarea"
                        placeholder="请输入"
                        v-model="item.remark"
                        maxlength="2000"
                        show-word-limit
                    />
                </div>
                <!-- 添加附件 -->
                <AddAnnex
                    :echoFileData="item.file"
                    @confirm="addAnnexConfirm($event, index)"
                    @fileClose="fileClose($event, index)"
                />
            </div>
        </div>
        <el-button type="primary" icon="el-icon-plus" @click="add"> 添加</el-button>
    </div>
</template>

<script>
import AddAnnex from '../../C/AddAnnex.vue'
import { onlineUpdate } from '@/api/schemeReview.js'
    export default {
        components: {
            AddAnnex
        },
        props: {
            // 接收的数据
            editOnlineData: {
                type: Object,
                default: () => {}
            }
        },
        data() {
            return {
                editData: {},
            }
        },
        mounted () {
            this.editData = this.editOnlineData && JSON.parse(JSON.stringify(this.editOnlineData))
        },
        methods: {
            // 添加附件确认后回传数据
            addAnnexConfirm (data,index) {
                this.editData.question[index].file = data
            },

            // 删除上传的附件
            fileClose(data ,i) {
                this.editData.question[i].file.forEach((item, j) => {
                    if (item.fileList[0] && item.fileList[0].fileUrl == data.fileList[0].fileUrl) {
                        this.editData.question[i].file.splice(j, 1)
                    }
                });
            },
            // 添加
            add () {
                if (this.editData.question.length > 9) return this.$message({message: '最多支持添加10条数据',type: 'warning'});
                this.editData.question.push({
                    remark: '',
                    file: [],
                    question_id: this.editData.question.length +1,
                    title: '线上递交问题'
                },)
            },
            // 删除
            deleteFn (index) {
                this.editData.question.splice(index, 1)
            },

            // 保存数据
            async saveInfo () {
                const params = {
                    order_id: this.$route.params.id,
                    question:[]
                }
                this.editData.question.forEach(item => {
                    params.question.push(item)
                })
                const { code } = await onlineUpdate(params)
                if (code == 200) {
                    this.$message({
                        message: '编辑成功',
                        type: 'success'
                    });
                }
            }
        },
    }
</script>

<style lang="less" scoped>
.letter{
    a{
    color: #409eff;
    font-size: 12px;
    margin-right: 20px;
}
    .remarks{
        >div{
            margin-bottom: 20px;
        }
    }
    .delete{
        display: flex;
        justify-content: space-between;
    }
}
</style>
